import * as React from 'react';

import { Button } from '../../../../components/Button/Button';
import { useCalCom } from '../../../../utils/useCalCom';

export const ContactUsButton = () => {
  const calComProps = useCalCom();

  return (
    <Button
      target="_blank"
      variant="solid"
      theme="current"
      size="xl"
      trackEvent="primary-navigation-contact-us"
      {...calComProps}
    >
      Hire Martians
    </Button>
  );
};
